import ParseDecimalNumber from 'parse-decimal-number';

const decimal = (value) => {
  if (typeof (value) === 'number') {
    return value;
  }
  return ParseDecimalNumber(value, '.,');
};

const parse = {
  decimal,
};

export default parse;
